module.exports = __webpack_public_path__ + "img/12.29f19a7f.png";